'use client';

import { css } from '@bts-web/utils-style-engine';

const SkeletonItem = ({
  className = '',
  width = '100%',
  height = '40px',
  borderRadius = '0px',
  testId,
  maxWidth,
  minWidth,
  backgroundColor = 'neutrals.fill_focused',
  ...rest
}: {
  className?: string;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  height?: string;
  borderRadius?: string;
  testId?: string;
  backgroundColor?: string;
  [key: string]: any;
}) => (
  <div
    className={`${css({
      width: width,
      height: height,
      background: backgroundColor,
      borderRadius: borderRadius,
      maxWidth,
      minWidth,
    })} ${className ?? ''}`}
    data-testid={testId || 'skeleton-element'}
    {...rest}
  ></div>
);

export const AccordionItemSkeleton = () => (
  <div
    className={css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomWidth: '1px',
      borderBottomColor: 'neutrals.stroke_secondary',
      flex: 'auto',
      minHeight: '89px',
      maxHeight: '106px',
    })}
    data-testid="list-element-skeleton"
  >
    <SkeletonItem
      width="135px"
      height="41px"
      className={css({ margin: 'small' })}
    />
    <SkeletonItem
      width="63px"
      height="41px"
      className={css({ margin: 'small' })}
    />
  </div>
);
